import {ChangeDetectionStrategy, Component} from '@angular/core';
import {ModalWrapperComponent} from '@components/views/modal-wrapper/modal-wrapper.component';
import {TermsComponent} from '@components/ui/terms/terms.component';

@Component({
    selector: 'app-terms-modal',
    templateUrl: './terms-modal.component.html',
    styleUrls: ['./terms-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [ModalWrapperComponent, TermsComponent]
})
export class TermsModalComponent {
}
